import { ArrowLeft } from "lucide-react";

/*
 * En tete sticky du diagnostic : retour, barre de progression, compteur.
 */
export const DiagnosticHeader = ({ progress, index, total, onBack }) => (
  <div className="sticky top-0 z-40 bg-[rgba(249,254,255,0.92)] backdrop-blur-sm border-b border-[rgba(35,82,119,0.08)]">
    <div className="max-w-[560px] mx-auto px-4 py-3">
      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid="diagnostic-back-button"
          onClick={onBack}
          aria-label="Question précédente"
          className="shrink-0 w-11 h-11 -ml-2 rounded-full flex items-center justify-center text-[#235277] hover:bg-[#E2F6FF] transition-colors duration-150"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <div className="flex-1">
          <div
            data-testid="diagnostic-progress-bar"
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
            className="h-2 rounded-full bg-[rgba(35,82,119,0.12)] overflow-hidden"
          >
            <div
              className="h-full rounded-full bg-[#235277] transition-[width] duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
        <span className="shrink-0 text-xs font-medium text-[#9E9E9E] tabular-nums" data-testid="diagnostic-question-counter">
          {index + 1}/{total}
        </span>
      </div>
    </div>
  </div>
);
